"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShopifySyncSettings = exports.getShopifyStoreStatuses = exports.getShopifyErrorStatuses = exports.getFetchShopifySyncSettingsStatus = exports.getFetchShopifyStatusesRequestStatus = exports.getShopifyState = void 0;

var _reselect = require("reselect");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getShopifyState = function getShopifyState(state) {
  return state.modules.ecommerce.shopify;
};

exports.getShopifyState = getShopifyState;
var getFetchShopifyStatusesRequestStatus = (0, _getRequestStatus.default)(_actions.ShopifyActionTypes.FETCH_STORES_STATUSES);
exports.getFetchShopifyStatusesRequestStatus = getFetchShopifyStatusesRequestStatus;
var getFetchShopifySyncSettingsStatus = (0, _getRequestStatus.default)(_actions.ShopifyActionTypes.FETCH_SYNC_SETTINGS);
exports.getFetchShopifySyncSettingsStatus = getFetchShopifySyncSettingsStatus;
var getShopifyErrorStatuses = (0, _reselect.createSelector)([getShopifyState], function (state) {
  return state.filter(function (storeStatus) {
    return storeStatus.integrationStatus != 'CONNECTED';
  });
});
exports.getShopifyErrorStatuses = getShopifyErrorStatuses;
var getShopifyStoreStatuses = (0, _reselect.createSelector)([getShopifyState], function (state) {
  return state.get('storeStatus');
});
exports.getShopifyStoreStatuses = getShopifyStoreStatuses;
var getShopifySyncSettings = (0, _reselect.createSelector)([getShopifyState], function (state) {
  return state.get('syncSettings');
});
exports.getShopifySyncSettings = getShopifySyncSettings;